import * as React from 'react';
import { invariant } from '@/util/invariant';

interface ContextType {
  hideDisabledSections: boolean;
  toggleHideDisabledSections: () => void;
}

const Context = React.createContext<ContextType | null>(null);

export const FilterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [hideDisabledSections, setHideDisabledSections] = React.useState(false);

  const value = React.useMemo<ContextType>(
    () => ({
      hideDisabledSections,
      toggleHideDisabledSections: () =>
        setHideDisabledSections((prev) => !prev),
    }),
    [hideDisabledSections],
  );

  return <Context value={value}>{children}</Context>;
};

export function useFilterContext() {
  const context = React.use(Context);

  invariant(context, 'useFilterContext must be used within a FilterProvider');

  return context;
}
